import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  constructor(private readonly http: HttpClient) {}
  getHttpHeaders(): Headers {
    const headers = new Headers();
    headers.append('x-rapidapi-key', '962a261d3amshe957a1acab414eep13b360jsn7f9fb9b79935');
    headers.append('x-rapidapi-host', 'ip-geo-location.p.rapidapi.com');
    return headers;
  }
}
